import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Textarea } from "@/components/ui/textarea"
import { Plus, Trash2 } from "lucide-react"
import { Section, ColorField, Field } from "../../shared/components/EditorFields"

export function FooterEditor({ footer, onChange, locale }: { footer: { bgColor?: string; textColor?: string; text?: Record<string, string>; footerLinks: Array<{ title: Record<string, string>; url?: string }> }; onChange: (f: any) => void; locale: string }) {
  const links = footer.footerLinks ?? []

  const updateLink = (i: number, patch: Record<string, any>) => {
    const next = links.map((l, idx) => idx === i ? { ...l, ...patch } : l)
    onChange({ ...footer, footerLinks: next })
  }
  const removeLink = (i: number) => onChange({ ...footer, footerLinks: links.filter((_, idx) => idx !== i) })
  const addLink = () => onChange({ ...footer, footerLinks: [...links, { title: {}, url: "" }] })

  return (
    <Section title={`Footer (${links.length} link${links.length === 1 ? "" : "s"})`}>
      <p className="text-[11px] text-muted-foreground">
        Text shown/edited below is for {locale} — use the locale switcher above to change languages.
      </p>
      <div className="grid grid-cols-2 gap-2">
        <ColorField label="Background color" value={footer.bgColor} onChange={v => onChange({ ...footer, bgColor: v })} />
        <ColorField label="Text color" value={footer.textColor} onChange={v => onChange({ ...footer, textColor: v })} />
      </div>
      <Field label="Footer text">
        <Textarea
          value={footer.text?.[locale] ?? ""}
          onChange={e => onChange({ ...footer, text: { ...footer.text, [locale]: e.target.value } })}
          rows={2} className="text-sm"
        />
      </Field>
      <div className="space-y-1.5">
        {links.map((l, i) => (
          <div key={i} className="flex items-center gap-1.5 rounded border p-2">
            <Input
              value={l.title?.[locale] ?? ""}
              onChange={e => updateLink(i, { title: { ...l.title, [locale]: e.target.value } })}
              placeholder={`Title (${locale})`}
              className="h-7 flex-1 text-xs"
            />
            <Input
              value={l.url ?? ""}
              onChange={e => updateLink(i, { url: e.target.value })}
              placeholder="URL"
              className="h-7 flex-1 text-xs"
            />
            <button type="button" className="shrink-0 text-muted-foreground hover:text-destructive" onClick={() => removeLink(i)} title="Remove">
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        ))}
      </div>
      <Button variant="outline" size="sm" className="h-7 text-xs" onClick={addLink}>
        <Plus className="mr-1 h-3.5 w-3.5" /> Add footer link
      </Button>
    </Section>
  )
}

// ── PageContent ──────────────────────────────────────────────────────────────

